import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Llegas a clase sin saber exactamente qué rutina vas a dar', 'Tus alumnos no progresan porque no hay un orden claro de cargas y estímulos', 'Tienes grupos con niveles mezclados y no sabes cómo manejarlos al mismo tiempo', 'Cuando hay feriado o lluvia pierdes la continuidad del entrenamiento y la motivación del grupo', 'No puedes justificar un aumento de precio porque no tienes nada sistematizado ni visible', 'Pierdes horas cada semana buscando ejercicios en YouTube en lugar de entrenar tú mismo', 'Tus alumnos se estancan y se van porque no sienten que avanzan de verdad'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white border-y border-stone-200" data-id="element-132" data-mp="1szpts0e2j7x8">
      <div className="max-w-4xl mx-auto" data-id="element-133" data-mp="3idbg1vx5urge">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-134" data-mp="3iee47w33mfsm">
          Si eres profesor de funcional, esto te va a sonar conocido:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-135" data-mp="1yzn6nrrjjmjs">
          {pains.map((pain, index) => <div key={index} className="flex items-start bg-stone-50 p-4 rounded-xl border border-stone-200 shadow-sm" data-id="element-136" data-mp="1u2dgg9wbv6uw" data-mpi={index}>
              <XCircle className="w-6 h-6 text-coral-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-137" data-mp="27utgr2xugqs4" />
              <p className="text-stone-700 text-lg" data-id="element-138" data-mp="23thvtapx0tq9">❌ {pain}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-139" data-mp="1g3nkwyp5pf8n">
          <p className="text-2xl font-bold text-stone-900 mb-8 italic" data-id="element-140" data-mp="1b3hpd7frn8la">
            "¿Cuántas clases más vas a improvisar?"
          </p>
          <a href="#pricing" className="inline-flex items-center justify-center bg-coral-500 hover:bg-coral-600 text-white font-bold text-xl py-4 px-8 rounded-2xl transform transition hover:scale-105 shadow-lg shadow-coral-500/20 w-full sm:w-auto" data-id="element-141" data-mp="1p3sg8ah2sn6g">
            👉 BASTA DE IMPROVISAR — QUIERO MI FUNCIONAL 360
          </a>
        </div>
      </div>
    </section>;
}
export function ProductIntro() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-142" data-mp="1y3qcicjqrpn1">
      <div className="inline-block bg-coral-50 text-coral-600 font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider border border-coral-100" data-id="element-143" data-mp="225tor3e8iy9d">
        🏆 El Sistema N°1 para Profesores de Funcional
      </div>

      <h2 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-6" data-id="element-144" data-mp="1afgkgsvxq5ng">
        FUNCIONAL 360 — Colección Completa
      </h2>

      <h3 className="text-2xl md:text-3xl text-coral-500 font-bold mb-8" data-id="element-145" data-mp="1egikvd1l8nr0">
        12 Tomos + 6 Bonus — Todo resuelto, todos los niveles.
      </h3>

      <div className="flex flex-wrap justify-center gap-4 md:gap-12 text-lg font-medium text-stone-600" data-id="element-146" data-mp="1o6lnm4yihg2j">
        <div className="bg-white px-6 py-4 rounded-2xl border border-stone-200 shadow-sm" data-id="element-147" data-mp="qr7tgm64o5pj">
          <span className="block text-3xl font-bold text-stone-900 mb-1" data-id="element-148" data-mp="vp9al1jztuyd">
            +280
          </span>
          páginas
        </div>
        <div className="bg-white px-6 py-4 rounded-2xl border border-stone-200 shadow-sm" data-id="element-149" data-mp="o5q99f6vtf0z">
          <span className="block text-3xl font-bold text-stone-900 mb-1" data-id="element-150" data-mp="j8go4bqizpiy">
            +150
          </span>
          ejercicios graficados
        </div>
        <div className="bg-white px-6 py-4 rounded-2xl border border-stone-200 shadow-sm" data-id="element-151" data-mp="a6h55dvyabdd">
          <span className="block text-3xl font-bold text-stone-900 mb-1" data-id="element-152" data-mp="57dyxq48hz3t">
            Todos
          </span>
          los niveles
        </div>
      </div>
    </section>;
}